import { render, staticRenderFns } from "./QualificationList.vue?vue&type=template&id=cfa8c878&scoped=true"
import script from "./QualificationList.vue?vue&type=script&lang=js"
export * from "./QualificationList.vue?vue&type=script&lang=js"
import style0 from "./QualificationList.vue?vue&type=style&index=0&id=cfa8c878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa8c878",
  null
  
)

export default component.exports